import { render, staticRenderFns } from "./snippets-summary-list.vue?vue&type=template&id=3e06197e&scoped=true&"
import script from "./snippets-summary-list.vue?vue&type=script&lang=js&"
export * from "./snippets-summary-list.vue?vue&type=script&lang=js&"
import style0 from "./snippets-summary-list.vue?vue&type=style&index=0&id=3e06197e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06197e",
  null
  
)

export default component.exports